module.exports = __webpack_public_path__ + "img/image1.819cfd40.jpeg";